'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFormFields;
function getFormFields(object) {
  var currentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var allFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return Object.keys(object).reduce(function (allFields, key) {
    currentPath.push(key);
    if (Array.isArray(object[key])) {
      object[key].forEach(function (formItem, index) {
        currentPath.push(index);
        getFormFields(object[key][index], currentPath, allFields);
        currentPath.pop();
      });
    } else if (object[key] === Object(object[key]) && 'value' in object[key]) {
      allFields[currentPath.join('.')] = object[key];
    } else if (object[key] === Object(object[key])) {
      getFormFields(object[key], currentPath, allFields);
    }
    currentPath.pop();

    return allFields;
  }, allFields);
}
//# sourceMappingURL=getFormFields.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/helpers/getFormFields.js
// module id = 306
// module chunks = 5